import { DayOfWeek } from '../../enums/DayOfWeek';
import { EmployeePositionId } from '../employee/Employee';

/**
 * An assignment in the rota when an employee is available.
 */
export class RotaAvailabilityAssignment {
  employeePositionId: EmployeePositionId;
  dayOfWeek: DayOfWeek;
  startTime: string;
  endTime: string;

  /**
   * @param employeePositionId the identifier of the employee and position.
   * @param dayOfWeek the day of week of the assignment.
   * @param startTime the start time of the assignment.
   * @param endTime the end time of the assignment.
   */
  constructor(
    employeePositionId: EmployeePositionId,
    dayOfWeek: DayOfWeek,
    startTime: string,
    endTime: string
  ) {
    this.employeePositionId = employeePositionId;
    this.dayOfWeek = dayOfWeek;
    this.startTime = startTime;
    this.endTime = endTime;
  }

  hasEqualEmployeeAndDay(employeePositionId: EmployeePositionId, dayOfWeek: DayOfWeek): boolean {
    return this.employeePositionId.value === employeePositionId.value && this.dayOfWeek === dayOfWeek;
  }
}


